import React from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";

export default function SectionCard({ title, subtitle, right, children, sx }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        ...sx,
      }}
    >
      <CardContent>
        {title ? (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            sx={{ mb: 2 }}
          >
            <div>
              <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                {title}
              </Typography>
              {subtitle ? (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              ) : null}
            </div>
            {right ? <div>{right}</div> : null}
          </Stack>
        ) : null}

        {children}
      </CardContent>
    </Card>
  );
}

